module.exports = __webpack_public_path__ + "static/media/arrow-prev-outline.569b6eff.svg";